import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
    addSelectedLayer,
    removeSelectedLayer
} from '../../../../redux/panel/print/Actions';
import withStyles from '@material-ui/core/styles/withStyles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import SelectTextField from '../../../Common/UI/SelectTextField';

class SizeSettings extends React.Component {
    constructor (props) {
        super(props);
    }

    render () {
        const {
            classes,
            scale,
            paperSize,
            setScale,
            setPaperSize
        } = this.props;

        return (
            <div className={classes.root}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <SelectTextField
                            label="Paper Size"
                            fullWidth
                            labelId="paper-size-label"
                            id="paper-size-select"
                            variant="outlined"
                            value={paperSize}
                            onChange={(e) => setPaperSize(e.target.value)}
                        >
                            <MenuItem value={'a2'}>A2</MenuItem>
                            <MenuItem value={'a3'}>A3</MenuItem>
                            {/* <MenuItem value={'a4'}>A4</MenuItem>
                            <MenuItem value={'a5'}>A5</MenuItem> */}
                        </SelectTextField>
                    </Grid>
                    <Grid item xs={6}>
                        <SelectTextField
                            label="Map Scale"
                            fullWidth
                            labelId="map-scale-label"
                            id="map-scale-select"
                            variant="outlined"
                            value={scale}
                            onChange={(e) => setScale(e.target.value)}
                        >
                            <MenuItem value={'1250'}>1:1250</MenuItem>
                            <MenuItem value={'2500'}>1:2500</MenuItem>
                            <MenuItem value={'5000'}>1:5000</MenuItem>
                            <MenuItem value={'10000'}>1:10000</MenuItem>
                            <MenuItem value={'25000'}>1:25000</MenuItem>
                            <MenuItem value={'50000'}>1:50000</MenuItem>
                            <MenuItem value={'100000'}>1:100000</MenuItem>
                            <MenuItem value={'250000'}>1:250000</MenuItem>
                            <MenuItem value={'500000'}>1:500000</MenuItem>
                        </SelectTextField>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const style = theme => ({
    root: {
        marginBottom: 15
    }
});

const mapStateToProps = state => {
    return {
        layers: state.layers.layers,
        selectedLayers: state.print_panel.selectedLayers
    };
};

const mapDispatchToProps = dispatch => ({
    dispatchAddSelectedLayer: (systemName) => dispatch(addSelectedLayer(systemName)),
    dispatchRemoveSelectedLayer: (systemName) => dispatch(removeSelectedLayer(systemName))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(SizeSettings);